import { Injectable } from '@angular/core';
import { AppRoutes } from '@core-types/app-routes.type';

@Injectable({
  providedIn: 'root',
})
export class NavigatorAssistant {
  static processRoutes(routesConfig: AppRoutes): AppRoutes {
    // implement there: build navigation tree logic for ai agent
    // - grab only routes with data: { assistant: { ... }} } and not data: { assistant: { ignore: true }} }
    // - error if registered with lazyload without (ignoreChildren: true)
    // - if not ignored, title and description are required
    return routesConfig;
  }
}
